import { createContext, useState, useContext } from 'react';

type Showtype = {
  show: any;
  setShow: React.Dispatch<React.SetStateAction<any>>;
};
export const ShowContext = createContext<Showtype | null>(null);
export const ShowContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [show, setShow] = useState(null);
  return (
    <ShowContext.Provider value={{ show, setShow }}>
      {children}
    </ShowContext.Provider>
  );
};

export function useShowfunction() {
  const context = useContext(ShowContext);
  if (context === null) {
    throw new Error('do not use this outside of context');
  }
  return context;
}
